<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Vendite</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Eliminati:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Con Eliminati</option>
          <option value="only">Solo Eliminati</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('sales.create')">
        <span>Crea</span>
        <span class="hidden md:inline">Vendita</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-3">SKU</th>
          <th class="px-6 pt-6 pb-3">SKU2</th>
        </tr>
        <tr v-for="sale in sales.data" :key="sale.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('sales.edit', sale.id)">
              {{ sale.sku }}
              <icon v-if="sale.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('sales.edit', sale.id)">
              {{ sale.sku2 }}
              <icon v-if="sale.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="sales.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nessuna vendita trovata</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="sales.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Vendite' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    sales: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('sales'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
